<template>
  <div>
    <LoadedComponent :loading="loading" />

    <div class="container-fluid mb-4" v-if="!loading">
      <div class="row">
        <div class="col-12 mt-4">
          <div class="card shadow-sm bg-white p-lg-5 p-2">
            <h4 class="text-center display-5">Cerca</h4>
            <div class="row">
              <div class="col-md-9">
                <form>
                  <input
                    type="search"
                    class="form-control"
                    name="q"
                    id="ws"
                    placeholder="Cerca fra i meeting"
                    v-model="searchText"
                    @input="performSearchMeeting"
                  />
                </form>
              </div>
              <div class="col-md-3">
                <router-link
                  to="meeting/create"
                  class="btn btn-outline-secondary nav-link w-100"
                  >Crea un nuovo meeting
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mb-4" v-if="loading == false">
      <div class="row mb-lg-4">
        <div
          class="col-12 col-sm-6 col-xl-3 align-items-stretch flex-column p-2"
          v-for="meeting in meetings"
          :key="meeting.id"
        >
          <div class="card shadow-sm d-flex flex-fill">
            <div class="card-body">
              <div class="float-left mr-3 text-center">
                <div
                  v-if="meeting.cover != null"
                  style="max-width: 160px; max-height: 100px"
                >
                  <img
                    :src="meeting.cover.path"
                    :alt="'Foto copertina ' + meeting.name"
                    style="max-height: 90px"
                  />
                </div>
                <div v-else style="max-width: 160px; max-height: 90px">
                  <img
                    src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/immagine_default.jpg"
                    :alt="'Foto copertina ' + meeting.name"
                    style="max-height: 106px"
                  />
                </div>

                <div v-if="meeting.shows == true">
                  <button
                    type="button"
                    class="btn-xs btn mt-2 p-0 d-block text-left"
                    style="text-transform: capitalize !important"
                    @click="checkMeeting(meeting.status, meeting.slug)"
                  >
                    <span
                      class="small badge rounded-pill badge-success p-2 border"
                      style="font-size: 14px"
                    >
                      <i class="las la-lock-open"></i>
                    </span>
                    Puoi accedere
                  </button>
                </div>
                <div v-else>
                  <button
                    type="button"
                    class="btn-xs btn mt-2 p-0 d-block text-left"
                    style="text-transform: capitalize !important"
                  >
                    <span
                      class="small badge rounded-pill badge-danger p-2 border"
                      style="font-size: 14px"
                    >
                      <i class="las la-door-closed"></i>
                    </span>
                    Riservato
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    class="btn-xs btn mt-1 p-0 d-block text-left"
                    style="text-transform: capitalize !important"
                    @click="checkMeeting(meeting.status, meeting.slug)"
                  >
                    <span
                      :class="
                        'small badge rounded-pill badge-' +
                        (meeting.allusers === true ? 'success' : 'danger') +
                        ' p-2 border'
                      "
                      style="font-size: 14px"
                    >
                      <i class="las la-users"></i>
                    </span>
                    {{
                      meeting.allusers === true
                        ? "Aperto a tutti"
                        : "Solo agli invitati"
                    }}
                  </button>
                </div>
                <div v-if="meeting.status == 'programming'">
                  <button
                    type="button"
                    class="btn-xs btn mt-1 p-0 d-block text-left"
                    style="text-transform: capitalize !important"
                    @click="checkMeeting(meeting.status, meeting.slug)"
                  >
                    <span
                      class="'small badge rounded-pill badge-secondary p-2 border'"
                      style="font-size: 14px"
                    >
                      <i class="las la-calendar-alt"></i>
                    </span>
                    Programmazione
                  </button>
                </div>
                <div v-else-if="meeting.status == 'progress'">
                  <button
                    type="button"
                    class="btn-xs btn mt-1 p-0 d-block text-left"
                    style="text-transform: capitalize !important"
                    @click="checkMeeting(meeting.status, meeting.slug)"
                  >
                    <span
                      class="'small badge rounded-pill badge-secondary p-2 border'"
                      style="font-size: 14px"
                    >
                      <i class="las la-video"></i>
                    </span>
                    Live ora
                  </button>
                </div>
                <div v-else-if="meeting.status === 'publish'">
                  <button
                    type="button"
                    class="btn-xs btn mt-1 p-0 d-block text-left"
                    style="text-transform: capitalize !important"
                    @click="checkMeeting(meeting.status, meeting.slug)"
                  >
                    <span
                      class="'small badge rounded-pill badge-secondary p-2 border'"
                      style="font-size: 14px"
                    >
                      <i class="las la-tv"></i>
                    </span>
                    Guarda la registrazione
                  </button>
                </div>
              </div>

              <h4 class="mb-0 ellipsis" style="font-size: 17px">
                {{ meeting.name }}
              </h4>

              <p class="mt-1 text-muted ellipsis" style="-webkit-line-clamp: 2">
                {{ meeting.description }}
              </p>
              <p class="mt-1 text-muted">
                <span
                  class="'small badge rounded-pill badge-info p-2 border'"
                  style="font-size: 14px"
                >
                  <i class="las la-clock"></i> </span
                >&nbsp; Inizio: {{ meeting.datetime_start }}
              </p>
              <p class="mt-1 text-muted">
                <span
                  class="'small badge rounded-pill badge-info p-2 border'"
                  style="font-size: 14px"
                >
                  <i class="las la-clock"></i> </span
                >&nbsp; Fine: {{ meeting.datetime_end }}
              </p>
            </div>
            <div class="card-footer">
              <div class="text-right">
                <button
                  @click="checkMeeting(meeting.status, meeting.slug)"
                  :class="
                    'btn btn-sm btn-success text-uppercase float-right' +
                    (meeting.show == true ? '' : 'disabled')
                  "
                >
                  Vai nel meeting
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import router from "@/router";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import httpservices from "@/services/httpservices.js";
export default {
  name: "MeetingPage",
  props: {},
  components: { LoadedComponent },
  data() {
    return {
      successMessage: "",
      errorMessage: "",
      meetings: [],
      allMeetings: [],
      errors: [],
      loading: true,
      searchText: "",
      meetingPermission: false,
    };
  },
  mounted() {
    this.successMessage = localStorage.getItem("messageSuccessMeeting");
    this.errorMessage = localStorage.getItem("messageErrorMeeting");
    if (this.successMessage !== null) {
      const $toast = useToast();
      $toast.open({
        message: this.successMessage,
        type: "success",
        position: "top-right",
        // all of other options may go here
      });
    }
    if (this.errorMessage !== null) {
      const $toast = useToast();
      $toast.open({
        message: this.errorMessage,
        type: "info",
        position: "top-right",
        // all of other options may go here
      });
    }
    httpservices
      .checkPermission(0, "meeting", "create_meeting")
      .then((response) => {
        this.meetingPermission = response.data.permission;
      });
    localStorage.removeItem("messageSuccessMeeting");
    localStorage.removeItem("messageErrorMeeting");
    httpauth
      .get("/meetings")
      .then((response) => {
        var data = response.data;
        this.meetings = data.data;
        this.allMeetings = data.data;
        this.loading = false;

        // Gestisci l'array di oggetti come desiderato
      })
      .catch((error) => {
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        ) {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        }
      });
  },
  created() {},
  methods: {
    performSearchMeeting() {
      if (!this.searchText) {
        this.meetings = this.allMeetings;
        return;
      }
      var searchTerm = this.searchText.toLowerCase();
      this.meetings = this.allMeetings.filter((item) =>
        item.name.toLowerCase().includes(searchTerm)
      );
    },
    checkMeeting(show, slug) {
      switch (show) {
        case "programming":
        case "progress":
          router.push("/meeting/show/" + slug);
          break;
        case "publish":
          router.push("/meeting/registration/" + slug);
          break;
      }
    },
  },
};
</script>

<style scoped>
.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3; /* Numero di righe massimo prima degli ellissi */
}
</style>